import React, { memo } from 'react'
import { string, node } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

const PricePerUOM = memo(({
  className, pricePerUOM, blk, children,
}) => {
  if (!pricePerUOM) return null

  return (
    <span className={classNames({ className, blk, elt: 'price-per-uom' })}>
      {children}
      {`(${pricePerUOM.toLowerCase()})`}
    </span>
  )
})

PricePerUOM.propTypes = {
  className: string,
  pricePerUOM: string,
  blk: string,
  children: node,
}
PricePerUOM.defaultProps = {
  className: '',
  pricePerUOM: '',
  blk: 'co-product',
  children: null,
}

export default PricePerUOM



// WEBPACK FOOTER //
// ./shared/interim/product/price-per-uom/index.js